import React from 'react'
import MuiTableContainer from '@material-ui/core/TableContainer'
import MuiTable from '@material-ui/core/Table'
import MuiTableBody from '@material-ui/core/TableBody'
import MuiTableHead from '@material-ui/core/TableHead'
import MuiTableRow from '@material-ui/core/TableRow'
import TableCell from 'components/dealwatch/TableCell'

const Table = ({ columnCount = 4, columnTitles = [], children: body, className }) => {
  while (columnTitles.length < columnCount) {
    columnTitles.push('')
  }

  return (
    <MuiTableContainer>
      <MuiTable {...{ className }}>
        <MuiTableHead classes={{ root: 'bg-white bb-medium bt-thick b--dark-sea-green-3 mt1' }}>
          <MuiTableRow>
            {columnTitles.map((title, index) => (
              <TableCell key={index} cxNames='b pv4'>{title}</TableCell>
            ))}
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {body}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  )
}

export default Table
